import { getDate } from '@/lib/tools/date-util'
import { cardNumberFilter } from '@/lib/tools/bank-card'
import * as _ from 'lodash'
import { JSEncrypt } from 'jsencrypt'
import store from '@/vuex/index'
import i18n from '@/i18n/i18n'
const webDetailTradeType = [{
	value: 'DEBIT',
	label: i18n.t('components.filter.tradeType.DEBIT'),
	options: [{
		value: 'PROCESSING',
		label: '处理中'
	},
	{
		value: 'PENDING',
		label: '付款中'
	},
	{
		value: 'SUCCESS',
		label: '成功'
	},
	{
		value: 'FAILED',
		label: '失败'
	},
	{
		value: 'CANCELED',
		label: '交易撤销'
	},
	{
		value: 'REVIEW',
		label: '待审核'
	}
	]
},
{
	value: 'REFUND',
	label: i18n.t('components.filter.tradeType.REFUND'),
	options: [{
		value: 'SUCCESS',
		label: '成功'
	},
	{
		value: 'FAILED',
		label: '失败'
	},
	{
		value: 'PROCESSING',
		label: '处理中'
	}
	]
},
{
	value: 'AUTH',
	label: i18n.t('components.filter.tradeType.AUTH'),
	options: [{
		value: 'PROCESSING',
		label: '处理中'
	},
	{
		value: 'SUCCESS',
		label: '成功'
	},
	{
		value: 'FAILED',
		label: '失败'
	},
	{
		value: 'PENDING',
		label: '付款中'
	}
	]
},
{
	value: 'CAPTURE',
	label: i18n.t('components.filter.tradeType.CAPTURE'),
	options: [{
		value: 'PROCESSING',
		label: '处理中'
	},
	{
		value: 'SUCCESS',
		label: '成功'
	},
	{
		value: 'FAILED',
		label: '失败'
	}

	]
},
{
	value: 'VOID',
	label: i18n.t('components.filter.tradeType.VOID'),
	options: [{
		value: 'PROCESSING',
		label: '处理中'
	},
	{
		value: 'SUCCESS',
		label: '成功'
	},
	{
		value: 'FAILED',
		label: '失败'
	}
	]
},
{
	value: 'APPROVE',
	label: i18n.t('components.filter.tradeType.APPROVE'),
	options: [{
		value: 'PROCESSING',
		label: '处理中'
	},
	{
		value: 'SUCCESS',
		label: '成功'
	},
	{
		value: 'FAILED',
		label: '失败'
	}
	]
},
{
	value: 'REJECT',
	label: i18n.t('components.filter.tradeType.REJECT'),
	options: [{
		value: 'PROCESSING',
		label: '处理中'
	},
	{
		value: 'SUCCESS',
		label: '成功'
	},
	{
		value: 'FAILED',
		label: '失败'
	}
	]
}, {
	value: 'PREDISPUTE_REFUND',
	label: i18n.t('components.filter.tradeType.PREDISPUTE_REFUND')
}
]
const webDetailStatus = [{
	value: 'PROCESSING',
	label: i18n.t('components.filter.tradeStatus.PROCESSING')
},
{
	value: 'PENDING',
	label: i18n.t('components.filter.tradeStatus.PENDING')
},
{
	value: 'SUCCESS',
	label: i18n.t('components.filter.tradeStatus.SUCCESS')
},
{
	value: 'FAILED',
	label: i18n.t('components.filter.tradeStatus.FAILED')
},
{
	value: 'CANCELED',
	label: i18n.t('components.filter.tradeStatus.CANCELED')
},
{
	value: 'REVIEW',
	label: i18n.t('components.filter.tradeStatus.REVIEW')
}
]

const normalizeLocale = lang => {
	const value = (lang || '').toLowerCase()
	if (value.indexOf('ja') > -1) return 'ja'
	if (value.indexOf('en') > -1) return 'en'
	if (value.indexOf('zh') > -1) return 'zh'
	return 'zh'
}

const getFilterLocaleLabel = (group, type, lang) => {
	const locale = normalizeLocale(lang)
	const localeMessage = i18n.getLocaleMessage(locale)
	return _.get(localeMessage, ['components', 'filter', group, type])
}

const getNewTradeTypeLocaleLabel = (type, lang) => {
	return getFilterLocaleLabel('tradeType', type, lang)
}

const getNewTradeStatusLocaleLabel = (type, lang) => {
	return getFilterLocaleLabel('tradeStatus', type, lang)
}

// 余额账户业务类型
// 资金流水业务类型
window.fundTypeLangList = [
	{
		value: '',
		zh: '全部',
		en: 'All',
		ja: 'すべて'
	},
	{
		value: 'PURCHASE',
		zh: '付款',
		en: 'Payment',
		ja: '支払い'
	},
	{
		value: 'PURCHASE_FEE',
		zh: '付款手续费',
		en: 'Payment fee',
		ja: '支払い手数料'
	},
	{
		value: 'DEPOSIT',
		zh: '循环保证金收取',
		en: 'Rolling Reserve',
		ja: 'ローリングリザーブ徴収'
	},
	{
		value: 'REFUND',
		zh: '退款',
		en: 'Refund',
		ja: '返金'
	},
	{
		value: 'REFUND_FEE',
		zh: '退款手续费',
		en: 'Return fee',
		ja: '返金手数料'
	},
	{
		value: 'DEPOSIT_RETURN',
		zh: '循环保证金退款返还',
		en: 'Rolling Reserve Release For Refund',
		ja: 'ローリングリザーブ返金返還'
	},
	{
		value: 'DEPOSIT_RELEASE',
		zh: '循环保证金到期返还',
		en: 'Rolling Reserve Expired Release',
		ja: 'ローリングリザーブ期限到来返還'
	},
	{
		value: 'CHARGE_BACK',
		zh: '拒付扣款',
		en: 'Chargeback deduction',
		ja: 'チャージバック差引'
	},
	{
		value: 'CB_ARBITRATION_FEE',
		zh: '拒付仲裁费扣款',
		en: 'Chargeback Arbitration Fee',
		ja: 'チャージバック仲裁手数料差引'
	},
	{
		value: 'CHARGE_BACK_RETURN',
		zh: '拒付返还',
		en: 'Chargeback Cancellation',
		ja: 'チャージバック返還'
	},
	{
		value: 'CB_ARBITRATION_FEE_RETURN',
		zh: '拒付仲裁费返还',
		en: 'Chargeback Arbitration Fee Retrun',
		ja: 'チャージバック仲裁手数料返還'
	},
	{
		value: 'CHARGE_BACK_FEE',
		zh: '拒付手续费',
		en: 'Chargeback fee',
		ja: 'チャージバック手数料'
	},
	{
		value: 'CHARGE_BACK_SUPP_FEE',
		zh: '拒付阶梯手续费',
		en: 'Chargeback Step-rate Fee',
		ja: 'チャージバック段階手数料'
	},
	{
		value: 'CHARGE_BACK_FEE_RETURN',
		zh: '拒付手续费返还',
		en: 'Chargeback Fee retrun',
		ja: 'チャージバック手数料返還'
	},
	{
		value: 'WITH_DRAW',
		zh: '提现',
		en: 'Withdrawal',
		ja: '出金'
	},
	{
		value: 'WITH_DRAW_FEE',
		zh: '提现手续费',
		en: 'Withdrawal fee',
		ja: '出金手数料'
	},
	{
		value: 'DEPOSIT_RELEASE_REVERSE',
		zh: '循环保证金到期返还撤销',
		en: 'Rolling Reserve Expired Release Cancel',
		ja: 'ローリングリザーブ期限到来返還取消'
	},
	{
		value: 'DECLINE_FEE',
		zh: '固定手续费',
		en: 'Fixed fee',
		ja: '固定手数料'
	},
	{
		value: 'OPEN_ACCOUNT_FEE',
		zh: '开户费用',
		en: 'Open account fee',
		ja: '口座開設手数料'
	},
	{
		value: 'TECHNICAL_SERVICES_FEE',
		zh: '技术服务费用',
		en: 'Technical service fee',
		ja: '技術サービス料'
	},
	{
		value: 'YEAR_FEE',
		zh: '年费',
		en: 'Yearly fee',
		ja: '年会費'
	},
	{
		value: 'MONTH_FEE',
		zh: '月费',
		en: 'Monthly fee',
		ja: '月額料金'
	},
	{
		value: 'FIX_DEPOSIT',
		zh: '固定保证金收取',
		en: 'Fixed deposit',
		ja: '固定保証金徴収'
	},
	{
		value: 'FIX_DEPOSIT_RETURN',
		zh: '固定保证金返还',
		en: 'Fixed Deposit Return',
		ja: '固定保証金返還'
	},
	{
		value: 'CHARGE_BACK_WARN_FEE',
		zh: '拒付预警手续费',
		en: 'Chargeback warn fee ',
		ja: 'チャージバック警告手数料'
	},
	{
		value: 'WITH_DRAW_REVERSE',
		zh: '提现返还',
		en: 'Withdraw funds return',
		ja: '出金返還'
	},
	{
		value: 'WITH_DRAW_FEE_REVERSE',
		zh: '提现手续费返还',
		en: 'Withdrawal fee return',
		ja: '出金手数料返還'
	}

]

// 拒付扣款、拒付返还、拒付仲裁费扣款、拒付仲裁费返还，提现
// 冻结账户业务类型
window.frozenLangList = [{
	value: 'All',
	zh: '全部',
	en: 'All',
	ja: 'すべて'
},
{
	value: 'WITH_DRAW_REQUEST',
	zh: '打款请求',
	en: 'Withdrawal Request ',
	ja: '送金依頼'
},
{
	value: 'WITH_DRAW',
	zh: '提现',
	en: 'Withdrawal',
	ja: '出金'
},
{
	value: 'CHARGE_BACK',
	zh: '拒付扣款',
	en: 'Chargeback deduction',
	ja: 'チャージバック差引'
},
{
	value: 'CHARGE_BACK_RETURN',
	zh: '拒付返还',
	en: 'Chargeback Cancellation',
	ja: 'チャージバック返還'
},
{
	value: 'CB_ARBITRATION_FEE',
	zh: '拒付仲裁费扣款',
	en: 'Chargeback Arbitration Fee',
	ja: 'チャージバック仲裁手数料差引'
},

{
	value: 'CB_ARBITRATION_FEE_RETURN',
	zh: '拒付仲裁费返还',
	en: 'Chargeback Arbitration Fee Retrun',
	ja: 'チャージバック仲裁手数料返還'
},
{
	value: 'WITH_DRAW_CANCEL',
	zh: '打款失败',
	en: 'Withdraw funds return',
	ja: '送金失敗'
}

]

window.depositAccountList = [{
	value: 'All',
	zh: '全部',
	en: 'All',
	ja: 'すべて'
},
{
	value: 'DEPOSIT',
	zh: '循环保证金收取',
	en: 'Rolling Reserve',
	ja: 'ローリングリザーブ徴収'
}, {
	value: 'DEPOSIT_RETURN',
	zh: '循环保证金退款返还',
	en: 'Rolling Reserve Release For Refund',
	ja: 'ローリングリザーブ返金返還'
}, {
	value: 'DEPOSIT_RELEASE',
	zh: '循环保证金到期返还',
	en: 'Rolling Reserve Expired Release',
	ja: 'ローリングリザーブ期限到来返還'
}
]

window.fixDepositAccountList = [{
	value: 'All',
	zh: '全部',
	en: 'All',
	ja: 'すべて'
},
{
	value: 'FIX_DEPOSIT',
	zh: '固定保证金收取',
	en: 'Fixed Deposit',
	ja: '固定保証金徴収'
}, {
	value: 'FIX_DEPOSIT_RETURN',
	zh: '固定保证金退还',
	en: 'Fixed Deposit Return',
	ja: '固定保証金返還'
}
]

export default {
	encrypt(pwd, publicKey) {
		const publicMapper = {
			local: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALVIdHfBpUCPgzAcPpmQsb72+Bhhxltvaa0+bxE4KdELDOvyQRCTf77dQX4DLDZmc5esj9zVN6YjxGbW1SW2lp8CAwEAAQ==',
			development: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALVIdHfBpUCPgzAcPpmQsb72+Bhhxltvaa0+bxE4KdELDOvyQRCTf77dQX4DLDZmc5esj9zVN6YjxGbW1SW2lp8CAwEAAQ==',
			test: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALVIdHfBpUCPgzAcPpmQsb72+Bhhxltvaa0+bxE4KdELDOvyQRCTf77dQX4DLDZmc5esj9zVN6YjxGbW1SW2lp8CAwEAAQ==',
			sandbox: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALVIdHfBpUCPgzAcPpmQsb72+Bhhxltvaa0+bxE4KdELDOvyQRCTf77dQX4DLDZmc5esj9zVN6YjxGbW1SW2lp8CAwEAAQ==',
			// production: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJqp3laSw+Dt1LQ5bIuaYE1fXriLgqr0gwKjySb3xUbmqsU7FrChuHTKUrByBtzQj9Oj8pHvEbQonp3Fs0n28W8CAwEAAQ==',
			production: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJqp3laSw+Dt1LQ5bIuaYE1fXriLgqr0gwKjySb3xUbmqsU7FrChuHTKUrByBtzQj9Oj8pHvEbQonp3Fs0n28W8CAwEAAQ=='
		}
		const _publicKey = publicMapper[process.env.NODE_ENV] || publicKey
		// try {
		// 	var publicKey = forge.pki.publicKeyFromPem(`-----BEGIN PUBLIC KEY-----${_publicKey}-----END PUBLIC KEY-----`);
		// 	// convert string to UTF-8 encoded bytes
		// 	var buffer = forge.util.createBuffer(pwd);
		// 	var bytes = buffer.getBytes();
		// 	// encrypt data with a public key using RSAES PKCS#1 v1.5
		// 	var encrypted = publicKey.encrypt(bytes, 'RSAES-PKCS1-V1_5');
		// 	// base64-encode encrypted data to send to server
		// 	var b64Encoded = forge.util.encode64(encrypted);
		// 	console.log(b64Encoded);
		// 	// alert(b64Encoded);
		// 	return b64Encoded

		// } catch (error) {
		// 	console.error(error)
		// }

		const encryptor = new JSEncrypt()
		// 设置公钥
		encryptor.setPublicKey(_publicKey)
		// 加密数据
		return encryptor.encrypt(pwd)
	},
	// 银行卡加密
	encryptionBankCard(bankCard) {
		if (bankCard) {
			bankCard = bankCard.toString()
			const endlen = bankCard.length
			const fourFist = bankCard.substr(0, 4)
			const last = bankCard.substr(endlen - 4, 4)
			return `${fourFist} **** **** ${last}`
		}
	},
	// 银行卡加密
	encryptionPhone(phone) {
		if (phone) {
			phone = phone.toString()
			const last = phone.substr(phone.length - 4, 4)
			return `*******${last}`
		}
	},
	toPercent(val) {
		const percent = val * 100 || 0
		return percent.toFixed(1) + '%'
	},
	/**
   * 小数转换为百分比，保留2位小数
   * 0.3  => 30.00%
   * @param twodDecimal
   * @returns {*}
   */
	twodDecimal(val) {
		const percent = val * 100 || 0
		return percent.toFixed(2) + '%'
	},
	/**
   * 格式化金额过滤器
   * 123456.78  =>  123,456.78
   * @param money
   * @returns {*}
   */
	money(money) {
		if (!money) {
			return '0.00'
		}
		if (money < 0.01) {
			return '0.00'
		}
		money = money + ''
		let num
		// 无小数点数字
		if (money.includes('.')) {
			num = +money.substr(0, money.indexOf('.') + 3)
		} else {
			num = +money + '.00'
		}
		// 截取小数点后2位
		// 12=> 12  12.1=> 12.1 12.126=> 12.12
		return ((isNaN(num) ? '0.00' : num) + '').replace(
			/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
			'$&,'
		)
	},
	// 截取小数点后两位，并且为负数则返回“0.00”
	pureMoney(money) {
		if (isNaN(+money)) {
			return '0.00'
		}
		if (!money) {
			return '0.00'
		}
		if (money < 0.01) {
			return '0.00'
		}
		money = money + ''
		let num
		// 无小数点数字
		if (money.includes('.')) {
			num = +money.substr(0, money.indexOf('.') + 3)
		} else {
			num = +money + '.00'
		}
		// 截取小数点后2位
		// 12=> 12  12.1=> 12.1 12.126=> 12.12
		return +num
	},
	// 截取小数点后两位，并且为负数不返回“0.00”，而是直接返回结果
	pureMoneyFushu(money) {
		if (isNaN(+money)) {
			return '0.00'
		}

		money = money + ''
		let num
		// 无小数点数字
		if (money.includes('.')) {
			num = +money.substr(0, money.indexOf('.') + 3)
		} else {
			num = +money + '.00'
		}
		// 截取小数点后2位

		return +num
	},
	nullReplace(money) {
		if (money === 0 || money === '0') {
			return '-'
		} else {
			return money
		}
	},
	/**
   * 格式化string金额过滤器
   * 123456.78  =>  123,456.78
   * @param money
   * @returns {*}
   */
	stringtoMoney(stringMoney) {
		if (!stringMoney) {
			return '0.00'
		}
		const num = parseFloat(stringMoney).toFixed(2)
		return ((isNaN(num) ? '0.00' : num) + '').replace(
			/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
			'$&,'
		)
	},
	right(value, len) {
		if (!value || value.length < len) {
			return value
		}
		return value.substring(value.length - len)
	},
	// 根据语言，获取账户余额业务类型、资金流水业务类型
	getEmerOptions(type, lang) {
		const ret = window[type].map(item => {
			const value = item.value
			const label = item[lang]
			return {
				label,
				value
			}
		})
		return ret
	},
	getLabel(type, value, lang) {
		const ret = window[type].find(item => item.value === value)
		if (ret) {
			return ret[lang]
		}
	},

	// 获取申诉结果
	getMerchantDealStatusLabel(depositStatus, lang = 'zh') {
		return getFilterLocaleLabel('merchantDealStatus', depositStatus, lang) || ''
	},

	// 获取拒付原因
	getChineseReason(depositStatus, lang = 'zh') {
		return getFilterLocaleLabel('chargebackReason', depositStatus, lang) || getFilterLocaleLabel('chargebackReason', 'OTHERS', lang) || ''
	},
	// 获取拒付进度中文描述
	getChargebackType(depositStatus, lang = 'zh') {
		return getFilterLocaleLabel('chargebackType', depositStatus, lang) || ''
	},
	// 获取保证金状态中文枚举值
	getDepositStatusName(depositStatus) {
		switch (depositStatus) {
			case 'DEPOSIT':
				return '新增保证金'
			case 'DEPOSIT_RETURN':
				return '保证金退款返还'
			case 'DEPOSIT_RELEASE':
				return '保证金到期返还'
		}
	},
	// 获取保证金状态中文枚举值
	getDepositStatus(depositStatusName) {
		switch ('depositStatusName') {
			case 'PARTIAL_RETURNED':
				return '已部分返还'
			case '已返还':
				return 'TOTAL_RETURNED'
			case '持有中':
				return 'IN_POSSESSION'
			default:
				return ''
		}
	},
	// 获取保证金业务类型类型映射
	getDepositFondTypeName(type) {
		switch (type) {
			case 'DEPOSITED':
				return '入账时存入'

			case 'REFUND_RETURNED':
				return '退款时返还'

			case 'AUTO_RETURNED':
				return '保证金到期后返还'
		}
	},
	getNewFondTypeName(type, lang = 'zh') {
		return getFilterLocaleLabel('newFondType', type, lang) || ''
	},
	// 业务类型名称映射
	getFondTypeName(type, lang = 'zh') {
		return getFilterLocaleLabel('fondType', type, lang) || ''
	},
	// 新款交易状态类型映射
	getNewTradeTypeName(type, lang = 'zh') {
		const localeLabel = getNewTradeTypeLocaleLabel(type, lang)
		if (localeLabel) {
			return localeLabel
		}

		const status = _.find(webDetailTradeType, ['value', type])
		if (!status) {
			return type || ''
		}

		return status.label
	},
	getNewTradeStatus(type, lang = 'zh') {
		const localeLabel = getNewTradeStatusLocaleLabel(type, lang)
		if (localeLabel) {
			return localeLabel
		}

		const status = _.find(webDetailStatus, ['value', type])
		if (!status) {
			return type || ''
		}

		return status.label
	},
	// 交易状态类型映射
	getTradeTypeName(type, lang = 'zh') {
		return getFilterLocaleLabel('tradeTypeName', type, lang) || ''
	},
	// 打款类型映射
	// lang 指定语言 默认zh
	getRecordState(type, lang = 'zh') {
		return getFilterLocaleLabel('recordState', type, lang) || ''
	},
	timestampToDatetimeNextLine(timestamp) {
		const _ = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09']
		const datetime = new Date(timestamp)
		const year = datetime.getFullYear()
		const month = datetime.getMonth() + 1
		const date = datetime.getDate()
		const hour = datetime.getHours()
		const minute = datetime.getMinutes()
		const second = datetime.getSeconds()
		return `${year}-${_[month] || month}-${_[date] || date}
    ${_[hour] || hour}:${_[minute] || minute}:${_[second] || second}`
	},
	timestampToDatetime(timestamp) {
		const _ = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09']
		const datetime = new Date(timestamp)
		const year = datetime.getFullYear()
		const month = datetime.getMonth() + 1
		const date = datetime.getDate()
		const hour = datetime.getHours()
		const minute = datetime.getMinutes()
		const second = datetime.getSeconds()
		return `${year}-${_[month] || month}-${_[date] || date} ${_[hour] || hour}:${_[minute] || minute}:${_[second] || second}`
	},
	timestampToDatetimeNohour(timestamp) {
		const datetime = new Date()
		datetime.setTime(timestamp)
		const year = datetime.getFullYear()
		const month = datetime.getMonth() + 1
		const date = datetime.getDate()
		return year + '-' + month + '-' + date
	},
	dateTime(val) {
		return getDate(val, 'YY-MM-DD HH:MM')
	},
	dateNormalTime(val) {
		return getDate(val, 'YY-MM-DD HH:MM:SS')
	},
	time(val) {
		return getDate(val, 'HH:MM:SS')
	},

	date(val) {
		val = new Date(val)
		return getDate(val, 'YY-MM-DD')
	},
	dateMonth(val) {
		return getDate(val, 'YY-MM')
	},
	bankNumber(val) {
		return cardNumberFilter(val)
	},
	platform(name, mode) {
		if (mode === 'name') {
			switch (name) {
				case 'amazon-us':
					return '北美亚马逊'
				case 'amazon-jp':
					return '日本亚马逊'
				case 'amazon-eu':
					return '欧洲亚马逊'
				case 'wish':
					return 'wish'
				case 'newegg':
					return 'newegg'
			}
		} else if (mode === 'logo') {
			switch (name) {
				case 'amazon-us':
					return 'amazon-logo'
				case 'amazon-jp':
					return 'amazon-logo'
				case 'amazon-eu':
					return 'amazon-logo'
				case 'wish':
					return 'wish-logo'
				case 'newegg':
					return 'newegg-logo'
				case 'opensky':
					return 'opensky-logo'
			}
		}
	},
	currency(name) {
		switch (name) {
			case 'USD':
				return '美元'
			case 'JPY':
				return '日元'
			case 'EUR':
				return '欧元'
			case 'CAD':
				return '加币'
			case 'GBP':
				return '英镑'
		}
	},
	getRandomNum(Min, Max) {
		const Range = Max - Min
		const Rand = Math.random()
		return Min + Math.round(Rand * Range)
	},
	getRandomcolor(index) {
		const colors = [
			'#FF8620',
			'#66B3FF',
			'#FF5D5D',
			'#795DFF',
			'#FF8620',
			'#66B3FF',
			'#FF5D5D',
			'#795DFF',
			'#FF8620',
			'#66B3FF',
			'#FF8620'
		]
		const i = Math.ceil(Math.random() * 10)
		return colors[i + 1]
	},

	currencylist() {
		const arr = [{
			label: 'AED',
			value: 'AED'
		},
		{
			label: 'AUD',
			value: 'AUD'
		},
		{
			label: 'BND',
			value: 'BND'
		},
		{
			label: 'BRL',
			value: 'BRL'
		},
		{
			label: 'CAD',
			value: 'CAD'
		},
		{
			label: 'CHF',
			value: 'CHF'
		},
		{
			label: 'CNY',
			value: 'CNY'
		},
		{
			label: 'COP',
			value: 'COP'
		},
		{
			label: 'CZK',
			value: 'CZK'
		},
		{
			label: 'DKK',
			value: 'DKK'
		},
		{
			label: 'EGP',
			value: 'EGP'
		},
		{
			label: 'EUR',
			value: 'EUR'
		},
		{
			label: 'FJD',
			value: 'FJD'
		},
		{
			label: 'GBP',
			value: 'GBP'
		},
		{
			label: 'HKD',
			value: 'HKD'
		},
		{
			label: 'HUF',
			value: 'HUF'
		},
		{
			label: 'IDR',
			value: 'IDR'
		},
		{
			label: 'IRR',
			value: 'IRR'
		},
		{
			label: 'ISK',
			value: 'ISK'
		},
		{
			label: 'JPY',
			value: 'JPY'
		},
		{
			label: 'KRW',
			value: 'KRW'
		},
		{
			label: 'KWD',
			value: 'KWD'
		},
		{
			label: 'LAK',
			value: 'LAK'
		},
		{
			label: 'LKR',
			value: 'LKR'
		},
		{
			label: 'MOP',
			value: 'MOP'
		},
		{
			label: 'MXN',
			value: 'MXN'
		},
		{
			label: 'MYR',
			value: 'MYR'
		},
		{
			label: 'NGN',
			value: 'NGN'
		},
		{
			label: 'NOK',
			value: 'NOK'
		},
		{
			label: 'NZD',
			value: 'NZD'
		},
		{
			label: 'PHP',
			value: 'PHP'
		},
		{
			label: 'PKR',
			value: 'PKR'
		},
		{
			label: 'PLN',
			value: 'PLN'
		},
		{
			label: 'QAR',
			value: 'QAR'
		},
		{
			label: 'RUB',
			value: 'RUB'
		},
		{
			label: 'SAR',
			value: 'SAR'
		},
		{
			label: 'SCR',
			value: 'SCR'
		},
		{
			label: 'SEK',
			value: 'SEK'
		},
		{
			label: 'SGD',
			value: 'SGD'
		},
		{
			label: 'THB',
			value: 'THB'
		},
		{
			label: 'TRY',
			value: 'TRY'
		},
		{
			label: 'TWD',
			value: 'TWD'
		},
		{
			label: 'USD',
			value: 'USD'
		},
		{
			label: 'VND',
			value: 'VND'
		},
		{
			label: 'ZAR',
			value: 'ZAR'
		},
		{
			label: 'BDT',
			value: 'BDT'
		},
		{
			label: 'NPR',
			value: 'NPR'
		},
		{
			label: 'MMK',
			value: 'MMK'
		}
		]
		return arr
	},
	permissionButton(val) {
		const asyncButton = store.getters.asyncButton
		if (asyncButton.includes(val)) return false
		else return true
	},
	permissionMenu(val) {
		const asyncMenu = store.getters.asyncMenu
		if (asyncMenu.includes(val)) return true
		else return false
	},

	getStoreType(type) {
		switch (type) {
			case 'direct':
				return i18n.t('storeManage.directStoreType')
			case 'franchise':
				return i18n.t('storeManage.franchiseStoreType')
			default:
				return ''
		}
	},

	getStoreStatus(status) {
		switch (status) {
			case 'APPROVE':
				return i18n.t('storeManage.approved')
			case 'DECLINE':
				return i18n.t('storeManage.decline')
			case 'PENDING':
				return i18n.t('storeManage.pending')
			case 'MODIFY':
				return i18n.t('storeManage.modify')
			default:
				return ''
		}
	},

	getStoreStatusIcon(status) {
		switch (status) {
			case 'APPROVE':
				return 'el-icon-success success'
			case 'DECLINE':
				return 'el-icon-error error'
			case 'PENDING':
				return 'el-icon-question question'
			case 'MODIFY':
				return 'el-icon-error error'
			default:
				return ''
		}
	},
	initLabels(list, mapLabel = { zh: 'name', en: 'enName', ja: 'jpName' }) {
		if (!Array.isArray(list)) return []
		const lang = normalizeLocale(localStorage.getItem('lang'))
		const currentLabelKey = mapLabel[lang]

		return list.map(item => {
			item.label = item[currentLabelKey]
			return item
		})
	}
}
